<template>
<div>
    <div v-if="sModoCampo=='1'">
      <span :class="claseError">{{onValidarPlaceholder(sLabel)}}</span>
      <span v-if="bObligatorio" class="font-weight-bold ml-1 red--text">*</span>
        <v-autocomplete
          class="mt-1"
          v-model="valor"
          v-bind="oAtributos"
          :disabled="onValidarDeshabilitado"
          :items="aData"
          :item-text="sCampoItem"
          :item-value="onValidacionMinusculas()"
          :placeholder="sPlaceholderTemp==''?sPlaceholder:sPlaceholderTemp"
          :loading="loadSelect"
          height="30px"
          :clearable="bClearable"
          dense
          :error="esError"
          :rules="noVacio"
          hide-details
        >
          <template slot="no-data">
            <div>No hay información</div>
          </template>
        </v-autocomplete>
    </div>
    <div v-else>
      <div class="mb-3">
        <span class="segundoEstiloTitulo">{{onValidarPlaceholder(sLabel)}}</span>
        <span v-if="bObligatorio" class="font-weight-bold ml-1 red--text">*</span>
      </div>
      <v-autocomplete
        v-model="valor"
        v-bind="oAtributos"
        :disabled="onValidarDeshabilitado"
        :items="aData"
        :item-text="sCampoItem"
        :item-value="sIdItem"
        :placeholder="sPlaceholderTemp==''?sPlaceholder:sPlaceholderTemp"
        :loading="loadSelect"
        :clearable="bClearable"
        dense
        solo
        flat
        :error="esError"
        :rules="bObligatorio ? [v => !!v || 'Este campo es obligatorio'] : []"
        hide-details="auto"
        class="mt-0 segundoEstilo"
        :class="{ bErrorClass: bError }"
      >
        <template slot="no-data">
          <div class="pa-2">No hay información</div>
        </template>
      </v-autocomplete>
    </div>
</div>
</template>

<script>

import axiosServices from "@/services/axiosServices.js"

export default {
  name: "FormSelect",
  components: {
  },
  props: {
    value: { },
    oAtributos:{
        type:Object,
        default:()=>{}
    },
    bObligatorio:{
        type: Boolean,
        default: false,
    },
    bEditable:{
        type: Boolean,
        default: true,
    },
    sLabel:{
        type: String,
        default: "",
    },
    sTabla:{
        type: String,
        default: "",
    },
    sIdItem:{
      type: String,
      default: "id",
    },
    sCampoItem:{
      type: String,
      default: "texto",
    },
    aItemsData:{
      type: Array,
      default: ()=>[],
    },
    sCampoModificaA:{
      type: String,
      default: "",
    },
    sCampoFiltro:{
      type: String,
      default: "",
    },
    nFiltro:{
      type: String,
      default: "-1",
    },
    sModoCampo:{
      type: String,
      default: "1",
    },
    bClearable:{
      type: Boolean,
      default: true,
    },
    sPlaceholder:{
      type: String,
      default() {
        return this.sTabla; 
      }
    },
    sGrupo:{
      type: String,
      default: "",
    },
    bError:{
        type: Boolean,
        default: false,
    }
  },
  data() {
    return {
      valor: this.value,
      itemsData: [],
      loadSelect: false,
      Mensaje: "Cargando..",
      esError: false,
      noVacio: [(v) => !!v],
      aData: [],
      aDataTemp:[],
      claseError:"",
      sPlaceholderTemp:""
    };
  },
  mounted() {
    this.getDatosTabla();
  },
  methods: {
    async getDatosTabla(){
      //Validamos si viene tipo URL para consultar al endpoint
      let aTipoURL = this.sTabla.split("$URL=");
      let aDataTemp =  [];
      if(aTipoURL.length==2){
        let oResult = await axiosServices.getConfiguration(aTipoURL[1], true);
        aDataTemp = oResult?.aData
      }
      else{
        aDataTemp = this.$store.state.dataBase.dataBase.find(item => item.tablaName==this.sTabla)?.info;
        //si la tabla no la en cuentra probablemente debe estar en la tablasGenerales
        if(aDataTemp==undefined){
          aDataTemp = [];
          let aTablaGeneral = this.$store.state.dataBase.dataBase.find(item => item.tablaName=="TablasGeneralesApp")?.info;
          if(aTablaGeneral!=undefined){
            aDataTemp = aTablaGeneral.filter(item => item.NombreTabla==this.sTabla);
          }
        }
  
      }
      aDataTemp.sort((a, b) => {
        // Cambia "Campo" por el nombre del campo por el que deseas ordenar
        if (a[this.sCampoItem] < b[this.sCampoItem]) return -1;
        if (a[this.sCampoItem] > b[this.sCampoItem]) return 1;
        return 0;
      });
      
      this.aData = aDataTemp;
      this.aDataTemp = this.aData;
    },
    onValidacionMinusculas(){
      if(this.sIdItem=="idSede" || this.sIdItem=="idsede"){
        //Validamos con cual de los dos esta trabajando
        if(this.aData?.length>0){
          if(this.aData[0]?.idSede){
            return "idSede";
          }
          else if(this.aData[0]?.idsede){
            return "idsede";
          }
        }
      }
      return this.sIdItem;
    },
    onValidarPlaceholder(sLabelTemp){
      if(sLabelTemp!=""){
        let aTempPlaceholder = sLabelTemp.split("$$");
        if(aTempPlaceholder?.length>0){
          this.sPlaceholderTemp = aTempPlaceholder[1]
        }
        return aTempPlaceholder[0]
      }
    }
  },
  computed: {
    onValidarDeshabilitado(){
      if(this.bEditable){
        if(this.sCampoFiltro!=null&&this.sCampoFiltro!="0"&&this.sCampoFiltro!=""&&this.nFiltro=="-1"){
          return true;
        }
        return false;
      }
      else{
        return true;
      }
    }
  },
  watch: {
    valor(NewValor) {
      
      this.$emit('input', NewValor);
      this.$emit('modificaA',{sCampoModificaA:this.sCampoModificaA,nId:NewValor,sIdItem:this.sIdItem})
      // let oDato  = this.aData.find((elemento) => elemento[this.sIdItem] == NewValor);
      if (NewValor !== this.valor) {
        this.valor = newValue;
      }
    },
    value(NewValor){
      this.valor = NewValor
    },
    nFiltro(newFiltro){
      this.aData = this.aDataTemp.filter(item=> item[this.sCampoFiltro]==newFiltro);
    }
  },
};
</script>

<style scoped>
.segundoEstiloTitulo{
  color: #0056D3;
  font-size: medium;
}
.segundoEstilo{
  border: 1px solid #ccc;
  border-radius: 10px;
}
.bErrorClass {
  border-color: red;
}
</style>